import { render, staticRenderFns } from "./ClamMstPopupTableInfo6.vue?vue&type=template&id=873dfc00&"
import script from "./ClamMstPopupTableInfo6.vue?vue&type=script&lang=js&"
export * from "./ClamMstPopupTableInfo6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports